// src/utils/filters.js
// General-purpose filter functions

/**
 * Filters an array of objects by a search string, searching in one or more properties.
 * @param {Array} array - The array to filter.
 * @param {string} search - The search string.
 * @param {...string} props - The property/properties to search in each object.
 * @returns {Array} - The filtered array.
 *
 * Usage:
 *   filterBy(array, 'search', 'name')
 *   filterBy(array, 'search', 'name', 'email')
 */
export function filterBy(array, search, ...props) {
  if (!search) return array
  const lowerSearch = search.toLowerCase()
  return array.filter(item => {
    // If no properties specified, search all values
    if (props.length === 0) {
      return Object.values(item).some(val =>
        String(val).toLowerCase().includes(lowerSearch)
      )
    }
    // Otherwise, search only in specified properties
    return props.some(prop => {
      const val = item[prop]
      return val !== undefined && String(val).toLowerCase().includes(lowerSearch)
    })
  })
}
